const subStyle = { paddingLeft: 10 };

export const TABS = [
  { label: 'Sales Value (Rp)', value: 'sales-value' },
  { label: 'Product Focus', value: 'product-focus' },
  { label: 'DOORS', value: 'doors' },
];
export const EMPTY_TABLE = ['status', 'created_by', 'last_updated', 'action'];

export const TABLE_STRUCTURES = {
  target_name: {
    head: 'Target Type',
    body: 'target_name',
    textStyle: { fontFamily: 'figtree-medium' },
  },
  status: {
    head: 'Status',
    body: 'status',
    type: 'status',
  },
  created_by: {
    head: 'Created By',
    body: 'created_by',
  },
  last_updated: {
    head: 'Last Updated By',
    body: 'last_updated',
  },
  action: {
    head: '',
    body: 'action',
    type: 'slot',
  },
};

export const SALES_VALUE_LIST = [
  {
    target_type: 'national',
    target_id: 'national',
    target_name: 'National Level',
    title: 'Sales Value - National Level',
    title_section: '',
    status: '',
    created_by: '',
    last_updated: '',
  },
  {
    target_type: 'channel',
    target_id: 'channel',
    target_name: 'Channel Level',
    title: 'Sales Value - Channel Level',
    title_section: '',
    status: '',
    created_by: '',
    last_updated: '',
  },
  {
    target_type: 'branch',
    target_id: 'branch',
    target_name: 'Branch Level',
    title: 'Branch Level',
    title_section: '',
    status: '',
    created_by: '',
    last_updated: '',
    empty: EMPTY_TABLE,
  },
  {
    target_type: 'branch-gt',
    target_id: 'branch-gt',
    target_name: 'GT',
    title: 'Sales Value - Branch GT',
    title_section: '',
    status: '',
    created_by: '',
    last_updated: '',
    textStyle: subStyle,
  },
  {
    target_type: 'branch-mt',
    target_id: 'branch-mt',
    target_name: 'MT',
    title: 'Sales Value - Branch MT',
    title_section: '',
    status: '',
    created_by: '',
    last_updated: '',
    textStyle: subStyle,
  },
  {
    target_type: 'salesman',
    target_id: 'salesman',
    target_name: 'Sales Team & Salesman Level',
    title: 'Sales Value - Sales Team',
    title_section: '',
    status: '',
    created_by: '',
    last_updated: '',
    empty: EMPTY_TABLE,
  },
  // {
  //   target_type: 'B2B Bogor',
  //   status: 'need_approval',
  //   created_by: new Date(),
  //   last_updated: new Date(),
  // },
];

export const PRODUCT_FOCUS_LIST = [
  {
    target_type: 'salesman',
    target_id: 'salesman',
    target_name: 'Salesman Type Level',
    title: 'Salesman Type Level',
    title_section: '',
    status: '',
    created_by: '',
    last_updated: '',
    empty: EMPTY_TABLE,
  },
  {
    target_type: 'salesman-gt',
    target_id: 'salesman-gt',
    target_name: 'GT',
    title: 'Product Focus - GT',
    title_section: '',
    status: '',
    created_by: '',
    last_updated: '',
    textStyle: subStyle,
  },
  {
    target_type: 'salesman-mt',
    target_id: 'salesman-mt',
    target_name: 'MT',
    title: 'Product Focus - MT',
    title_section: '',
    status: '',
    created_by: '',
    last_updated: '',
    textStyle: subStyle,
  },
];

export const DOORS_LIST = [
  {
    target_type: 'national',
    target_id: 'national',
    target_name: 'National Level',
    title: 'DOOR - National Level',
    title_section: '',
    status: '',
    created_by: '',
    last_updated: '',
  },
  // {
  //   target_type: 'salesman',
  //   target_id: 'salesman',
  //   target_name: 'Salesman Level',
  //   title: 'Salesman Level',
  //   title_section: '',
  //   status: '',
  //   created_by: '',
  //   last_updated: '',
  //   empty: EMPTY_TABLE,
  // },
  // {
  //   target_type: 'B2B Bogor',
  //   status: 'approved',
  //   created_by: new Date(),
  //   last_updated: new Date(),
  // },
  // {
  //   target_type: 'B2B Lampung',
  //   status: 'need_approval',
  //   created_by: new Date(),
  //   last_updated: new Date(),
  // },
];

export const MONTH_NUMBERS = {
  1: 'jan',
  2: 'feb',
  3: 'mar',
  4: 'apr',
  5: 'may',
  6: 'jun',
  7: 'jul',
  8: 'aug',
  9: 'sep',
  10: 'oct',
  11: 'nov',
  12: 'dec',
};

export const MONTH_OBJ_NUMBERS = {
  jan: 1,
  feb: 2,
  mar: 3,
  apr: 4,
  may: 5,
  jun: 6,
  jul: 7,
  aug: 8,
  sep: 9,
  oct: 10,
  nov: 11,
  dec: 12,
};

export const MONTH_KEYS = [
  'jan',
  'feb',
  'mar',
  'apr',
  'may',
  'jun',
  'jul',
  'aug',
  'sep',
  'oct',
  'nov',
  'dec',
];

export const MONTH_NUMBERS_FULLNAME = {
  1: 'January',
  2: 'February',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'September',
  10: 'October',
  11: 'November',
  12: 'December',
};

export const MONTH_TABLES = [
  { label: 'Jan', body: 'jan' },
  { label: 'Feb', body: 'feb' },
  { label: 'Mar', body: 'mar' },
  { label: 'Apr', body: 'apr' },
  { label: 'May', body: 'may' },
  { label: 'Jun', body: 'jun' },
  { label: 'Jul', body: 'jul' },
  { label: 'Aug', body: 'aug' },
  { label: 'Sep', body: 'sep' },
  { label: 'Oct', body: 'oct' },
  { label: 'Nov', body: 'nov' },
  { label: 'Dec', body: 'dec' },
  { label: 'Total', body: 'total' },
];

export const MONTH_TABLES_WITHOUT_TOTAL = [
  { label: 'Jan', body: 'jan' },
  { label: 'Feb', body: 'feb' },
  { label: 'Mar', body: 'mar' },
  { label: 'Apr', body: 'apr' },
  { label: 'May', body: 'may' },
  { label: 'Jun', body: 'jun' },
  { label: 'Jul', body: 'jul' },
  { label: 'Aug', body: 'aug' },
  { label: 'Sep', body: 'sep' },
  { label: 'Oct', body: 'oct' },
  { label: 'Nov', body: 'nov' },
  { label: 'Dec', body: 'dec' },
];

export const IGNORE_TARGET_ID = [
  'national',
  'channel',
  'branch-gt',
  'branch-mt',
  'branch',
  'salesman-gt',
  'salesman-mt',
  'salesman',
];
